/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react'

import { Layout } from 'src/components'

import { MiscApi } from './api'
import classes from './styles.module.scss'

export const PrivacyPolitics = () => {
  const [privacyPolitics, setPrivcyPolitics] = useState<string>()

  useEffect(() => {
    const fetch = async () => {
      const fetchedTermsAndConditions = await MiscApi.fetchPrivacyPolitics()
      setPrivcyPolitics(fetchedTermsAndConditions)
    }

    fetch()
  }, [])

  return (
    <Layout>
      <div
        dangerouslySetInnerHTML={{ __html: privacyPolitics ?? '' }}
        className={classes.container}
      />
    </Layout>
  )
}
